var loadedTime = new Date().toLocaleTimeString().replace(/(\d+:\d{2})(:\d{2})(.*)/, "$1$3");

Array.prototype.findIndex = Array.prototype.findIndex || function(callback) {
  if (this === null) {
    throw new TypeError('Array.prototype.findIndex called on null or undefined');
  } else if (typeof callback !== 'function') {
    throw new TypeError('callback must be a function');
  }
  var list = Object(this);
  // Makes sures is always has an positive integer as length.
  var length = list.length >>> 0;
  var thisArg = arguments[1];
  for (var i = 0; i < length; i++) {
    if ( callback.call(thisArg, list[i], i, list) ) {
      return i;
    }
  }
  return -1;
};

window.loadedURL = typeof URL === "function" && new URL(location.href);
window.toonAppData = {};
window.isTooncoinCom = window.location.origin.indexOf("tooncoin.com") > 0;

var queryParams = queryStringToObject(window.loadedURL.search.substring(1));
window.userSplitGroup = queryParams["split_group"] || window.localStorage.getItem("tooncoin:user_split_group") || (Math.floor(Math.random() * 10) + 1);
window.userSplitGroup = parseInt(window.userSplitGroup);
window.localStorage.setItem("tooncoin:user_split_group", window.userSplitGroup);

function getCurrentAccount() {
  if (window.ethereum.selectedAddress) {
    return Promise.resolve(window.ethereum.selectedAddress);
  }

  return ethActivate().then(function (accounts) {
    window.ethereum.selectedAddress = accounts[0];

    return accounts[0];
  });
}

localStorage["tooncoin:first_visit_at"] = localStorage["tooncoin:first_visit_at"] || Date.now();
if (!localStorage["tooncoin:howtobuy_variant"]) {
  localStorage["tooncoin:howtobuy_variant"] = (Math.random() > 0.5 ? "bot" : "page");
}

var howToBuyVariant = queryParams["howtobuy_variant"] || localStorage["tooncoin:howtobuy_variant"];

setInterval(function() {
  var firstVisitAt = parseInt(localStorage["tooncoin:first_visit_at"]);
  var now = Date.now();
  if ((now >= firstVisitAt + 10000) && !localStorage["tooncoin:first_visit_at:10s"]) {
    localStorage["tooncoin:first_visit_at:10s"] = true;
    logEvent("visit_10s");
  }

  if ((now >= firstVisitAt + 15000) && !localStorage["tooncoin:first_visit_at:15s"]) {
    localStorage["tooncoin:first_visit_at:15s"] = true;
    logEvent("visit_15s");
  }
}, 1000);

$(document).ready(function() {
  if (howToBuyVariant === "bot") {
    $(".js-howtobuy-link").attr("href", "https://t.me/ToonInfoBot");
    $(".js-howtobuy-link").attr("target", "_blank");
  }

  $(".js-place-time").text(loadedTime);

  // Sentry.init({
  //   dsn: "https://b593424ed7ec4f5093be259768258bf8@o508993.ingest.sentry.io/6303553",
  //   integrations: [new Sentry.BrowserTracing()],
  //   tracesSampleRate: 0.0,
  //   whitelistUrls: [/web3\.min\.js/, /jquery\.min\.js/, /script\.min\.js/],
  // });

  var queryParams = queryStringToObject(window.loadedURL.search.substring(1));
  if (queryParams["utm_source"] && /\-mm$/.test(queryParams["utm_source"])) {
    hit(8966);
  }

  document.addEventListener("beforeunload", function() {
    logEvent("page_unload");
  });

  if (location.href.indexOf("bitcoin_ask_popup_question") > 0) {
    showBitcoinAskPopup();
  }

  fetch("./price.json").then(function(res) {
    return res.json();
  }).then(function(res) {
    window.toonAppData = res;
    $(".js-contract-address").text(res.address);
    $(".js-token-price-text").text("$" + parseFloat(res.price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
    $(".js-eth-price").text("$" + parseFloat(res.ethRate).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
  });

  if (window.ethereum && typeof Web3 === "function") {
    window.web3 = new Web3(window.ethereum);
  }

  if (!window.localStorage["hit_user"]) {
    window.localStorage["hit_user"] = "1";
    hit(8915);
  }

  if (window.ethereum) {
    if (!window.localStorage["hit_ethereum"]) {
      window.localStorage["hit_ethereum"] = "1";
      hit(8914);
    }
  } else {
    if (false && window.outerWidth === window.screen.availWidth && window.outerWidth < 992 && window.userSplitGroup === 1) {
      $("#dapp-deeplink").addClass("shown");
      hit(8967);
    }
  }

  $(".dapp-deeplink-button").on("click", function() {
    hit(8965);

    var queryParams = queryStringToObject(window.loadedURL.search.substring(1));
    if (queryParams["utm_source"]) {
      queryParams["utm_source"] += "-mm";
    } else {
      queryParams["utm_source"] = "direct-mm";
    }

    var goToUrl = "https://metamask.app.link/dapp/"
      + window.loadedURL.host
      + window.loadedURL.pathname
      + ("?" + objectToQueryString(queryParams))
      + window.loadedURL.hash
    ;

    setTimeout(function() {
      // console.log(goToUrl);
      window.location.href = goToUrl;
    }, 200);
  });

  // var buttons = document.getElementsByClassName('button');
  // for(var i = 0; i < buttons.length; i++){
  //   buttons[i].href+=window.location.search;
  // }

//   cookiesUx(); //вызов ux, который происходит с куками
// //функция обработки куки
//   function getCookie(name) {
//     var matches = document.cookie.match(new RegExp(
//       "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
//     ));
//     return matches ? decodeURIComponent(matches[1]) : undefined;
//   }
// //функция установки куки
//   function setCookie(name, value, options) {
//     options = options || {};
//     var expires = options.expires;
//     if (typeof expires == "number" && expires) {
//       var d = new Date();
//       d.setTime(d.getTime() + expires * 1000);
//       expires = options.expires = d;
//     }
//     if (expires && expires.toUTCString) {
//       options.expires = expires.toUTCString();
//     }
//     value = encodeURIComponent(value);
//     var updatedCookie = name + "=" + value;
//     for (var propName in options) {
//       updatedCookie += "; " + propName;
//       var propValue = options[propName];
//       if (propValue !== true) {
//         updatedCookie += "=" + propValue;
//       }
//     }
//     document.cookie = updatedCookie;
//   }
//   function cookiesUx() { //ux, который происходит с куками
//     var cookiesBlock = document.getElementById('js_cookies'); // блок, который скрываем
//     if (getCookie('vectorCookies')) { //проверяем, если есть кука. Конечно, если заходим первый раз - ее нет.
//       cookiesBlock.hidden = true; // но если кука есть уже - блок скрываем. Почитай про hidden. Это по красоте.
//       return; //Прерываем выполнение остального кода.
//     }
//     // Если куки нет и условие не прошло - идем дальше.
//     var CookiesBlockOk = document.getElementById('js_cookies__ok'); // триггерим кнопку "ок"
//     var options = { // создаем объект куки с датой, когда она протухнет. это год. бессмертных кук не бывает!!!
//       expires: new Date(Date.now() + (1000 /*sec*/ * 60 /*min*/ * 60 /*hour*/ * 24 /*day*/ * 365))
//     };
//     CookiesBlockOk.addEventListener('click', function() { // по клику на ок - ставим куку с этими параметрами
//       setCookie('vectorCookies', 1, options);
//       cookiesBlock.hidden = true; //скрываем блок с предупреждением
//     });
//   }

  //smooth scrolling
  if($('.index-page').length > 0) {
    $(".header__menu-item:not(:last-of-type) a, .banner__button").on("click", function (event) {
      event.preventDefault();
      var id = $(this).attr('href'),
        top = $(id).offset().top;
      $('body,html').animate({scrollTop: top - 100}, 600);
    });
  }

  //mobile menu
  $('.btn-menu').click(function () {
    $('.header').toggleClass('active scrolled')
    $('.header__shadow').toggleClass('hidden')
    $('.btn-menu').toggleClass('active')
    $('.main').toggleClass('blur')
    $('body').toggleClass('noscroll')
    $('.header__menu-item a').click(function () {
      $('.header').removeClass('active')
      $('.header__shadow').addClass('hidden')
      $('.btn-menu').removeClass('active')
      $('.main').removeClass('blur')
      $('body').removeClass('noscroll')
    })
  })

  //fixed menu
  var menu = $('.main');
  var menuPosition;

  if ($(document).scrollTop() > 0) {
    $('.header').addClass('scrolled');
  }

  $(window).scroll (function () {
    var menuCoords = menu.offset();
    var windowScroll = $(this).scrollTop();
    if (!menuPosition) {
      menuPosition = menuCoords.top;
    }
    if (windowScroll > 0) {
      $('.header').addClass('scrolled')
    } else {
      menuPosition = false;
      $('.header').removeClass('scrolled')
    }
  });

  // photoapp
  goToAppStore = () => {
    window.open("https://apps.apple.com/app/id1635754347", "_blank");
  }

  goToPlayMarket = () => {
    window.open("https://play.google.com/store/apps/details?id=com.toonlabs.tooncoin", "_blank");
  }

  var $storePopup = $(".js-store-popup");

  $storePopup.click(function(e) {
    if ($(e.target).closest(".popup").length === 0) {
      $(document.body).removeClass("popup-show");
      $storePopup.addClass("hidden");
    }
  });

  $storePopup.find(".js-button--apple").click(function(e) {
    e.preventDefault();

    goToAppStore();

    $(document.body).removeClass("popup-show");
    $storePopup.addClass("hidden");
  });

  $storePopup.find(".js-button--google").click(function(e) {
    e.preventDefault();

    goToPlayMarket();

    $(document.body).removeClass("popup-show");
    $storePopup.addClass("hidden");
  });

  $storePopup.find(".js-button--close").click(function(e) {
    e.preventDefault();

    $(document.body).removeClass("popup-show");
    $storePopup.addClass("hidden");
  });

  // if (window.isMobile && window.isMobile.android.device) {
  //   $(".js-create-your-cartoon").hide();
  // }

  $(".js-create-your-cartoon").click(function(e) {
    e.preventDefault();

    if (window.isMobile && window.isMobile.android.device) {
      goToPlayMarket();
      return;
    }

    if (window.isMobile && window.isMobile.apple.device) {
      goToAppStore();
      return;
    }

    $(document.body).addClass("popup-show");
    $storePopup.removeClass("hidden");
  });

  //faq
  $('.faq__item').click(function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    }
    else {
      $(this).addClass("active");
    }
  })

  if (window.ethereum) {
    $(".js-purchase-form").removeClass("hidden");
  } else {
    $(".js-purchase-fallback").removeClass("hidden");
  }

  // contract purchase
  $(".js-purchase-form").on("submit", function(e) {
    e.preventDefault();

    var $messageBlock = $(e.currentTarget).find(".js-result-message");
    var $amountField = $(e.currentTarget).find("input[name='amount']");
    var amount = $amountField.length > 0
      ? Math.abs(parseFloat($amountField.val() || 0))
      : 0;

    amount = Math.max(0, amount);
    if (amount <= 0) {
      return;
    }

    $(".how__pay-loading").removeClass("hidden");
    $(".how__pay-error").addClass("hidden").text("");
    $messageBlock.addClass("hidden");

    debounce("purchase", 400, function() {
      getCurrentAccount()
        .then(function(account) {
          hit(window.isTooncoinCom ? 8845 : 8848);
          gtag("send", "event", "purchase", "request");

          logEvent("purhcase_request", {amount: amount, address: account});

          return window.web3.eth.sendTransaction({
            from: account,
            to: window.toonAppData.address,
            data: "0x64edfbf0e2c706ba4a09595315c45355a341a576cc17f3a19f43ac1c02f814ee",
            value: window.web3.utils.hexToNumberString(amount * 1e18),
          })
          .on("transactionHash", function(txHash) {
            $(".how__pay-loading").addClass("hidden");

            if (txHash !== undefined) {
              $amountField.val("");
              $messageBlock.removeClass("hidden");
              $messageBlock.find("a").attr("href", "https://etherscan.io/tx/" + txHash)
            }
          });
        })
        .then(function(receipt) {
          console.log("receipt:", receipt);

          hit(window.isTooncoinCom ? 8846 : 8849);
          gtag("send", "event", "purchase", "success");
          logEvent("purhcase_success", {amount: amount, address: window.ethereum.selectedAddress});
        })
        .catch(function(err) {
          console.error(err);

          hit(window.isTooncoinCom ? 8847 : 8850);
          gtag("send", "event", "purchase", "failure");
          logEvent("purhcase_failure", {amount: amount, address: window.ethereum.selectedAddress});

          $(".how__pay-loading").addClass("hidden");
          $(".how__pay-loading").addClass("hidden");

          if (err.code == 4001) {
            return;
          }

          $(".how__pay-error").removeClass("hidden").text(err.message);

          $([document.documentElement, document.body]).animate({
            scrollTop: $(".how__pay-error").offset().top - $(window).height()/2
          }, 2000);
        });
    });
  });

  logEvent("page_" + document.body.dataset.page);

  $(".js-bot-link").on("click", function(e) {
    logEvent("goto_bot_click", {href: $(e.currentTarget).attr("href")});
  });

  var howBuyBtn = document.querySelector('#howBuyButton');
  if (howBuyBtn) {
    howBuyBtn.addEventListener("click", function(e) {
      this.classList.toggle('active');
      document.querySelector('.how__crypto').classList.toggle('active');
      if (window.innerWidth <= 900) {
        document.body.classList.add('noscroll');
        document.querySelector('.how__crypto-close').addEventListener('click', (event) => {
          document.body.classList.remove('noscroll');
          howBuyBtn.classList.remove('active');
          document.querySelector('.how__crypto').classList.remove('active');
        })
      }
    });
  }

  var howCryptoForm = document.querySelector('.how__crypto-form');
  var howCryptoInput = document.querySelector('.how__crypto-input');

  if (howCryptoForm) {
    howCryptoForm.addEventListener("submit", function(e) {
      e.preventDefault();

      if (howCryptoInput.value.length > 0) {
        cryptoFormFunc();
      }
    });
  }

  function cryptoFormFunc() {
    logEvent("crypto_select", {
      is_custom: true,
      item: howCryptoInput.value,
    });

    howCryptoForm.classList.remove('active');
    howBuyBtn.innerHTML = '<svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="a" style="mask-type:alpha" x="0" y="0" width="48" height="48"><path fill="#D9D9D9" d="M0 0h48v48H0z"/></mask><g mask="url(#a)"><path d="M25 44C13.972 44 5 35.028 5 24S13.972 4 25 4a20.08 20.08 0 0 1 17.32 9.994.743.743 0 0 1-.27 1.013l-3.51 2.028a.75.75 0 0 1-1.022-.287C34.51 11.561 28.495 8.664 22.43 9.76c-6.922 1.258-12.032 7.491-11.895 14.526.153 7.846 6.583 14.182 14.465 14.182a14.509 14.509 0 0 0 12.14-6.6l-2.248-1.3A11.912 11.912 0 0 1 25 35.877c-6.549 0-11.877-5.328-11.877-11.877S18.451 12.13 25 12.13a11.92 11.92 0 0 1 9.854 5.248.747.747 0 0 1-.77 1.154.733.733 0 0 1-.445-.3A10.438 10.438 0 0 0 25 13.612c-5.865 0-10.61 4.88-10.386 10.79.165 4.374 3.142 8.248 7.326 9.532A10.4 10.4 0 0 0 34 29.2a.742.742 0 0 1 1.013-.271l3.528 2.04a.736.736 0 0 1 .28.997A15.992 15.992 0 0 1 25 39.953C16.206 39.95 9.05 32.795 9.05 24c0-8.795 7.156-15.95 15.95-15.95a16.006 16.006 0 0 1 13.425 7.339l2.228-1.287A18.6 18.6 0 0 0 25 5.482C14.79 5.482 6.482 13.79 6.482 24S14.79 42.518 25 42.518a18.596 18.596 0 0 0 15.662-8.634.744.744 0 0 1 1.352.201.742.742 0 0 1-.086.57A20.084 20.084 0 0 1 25 44z" fill="#FFD06A"/></g></svg>' + document.querySelector('.how__crypto-input').value;
    howBuyBtn.classList.add('selected');
    document.querySelector('.how__crypto').classList.remove('active');
    document.querySelector('.how__steps').classList.add('active');
    document.querySelector('.how__steps-name').textContent = howCryptoInput.value;
    if( window.innerWidth <= 900 ){
      document.body.classList.remove('noscroll');
    }
    setTimeout(function () {
      howCryptoInput.value = '';
      howCryptoForm.classList.remove('send');
    },100);
  }

  if (howCryptoInput) {
    howCryptoInput.addEventListener('input', (event) => {
      if (event.currentTarget.value.length > 0) {
        howCryptoForm.classList.add('send');
      } else {
        howCryptoForm.classList.remove('send');
      }
    });
  }

  var howCryptoItem = document.querySelectorAll('.how__crypto-item');
  for (let i = 0; i < howCryptoItem.length; i++) {
    howCryptoItem[i].addEventListener('click', (event) => {
      if( window.innerWidth <= 900 ){
        document.body.classList.remove('noscroll');
      }
      if(howCryptoItem[i].classList.contains('fav-crypto')) {
        howCryptoForm.classList.add('active');
        if( window.innerWidth <= 900 ){
          howCryptoForm.scrollIntoView({block: "start", behavior: "smooth"});
          console.log('kek')
        }
      } else {
        logEvent("crypto_select", {
          is_custom: false,
          item: howCryptoItem[i].querySelector("span").innerText.trim(),
        });

        howBuyBtn.classList.add('selected');
        howBuyBtn.innerHTML = howCryptoItem[i].innerHTML;
        document.querySelector('.how__crypto').classList.remove('active');
        document.querySelector('.how__steps').classList.add('active');
        document.querySelector('.how__steps-name').innerHTML = howCryptoItem[i].innerHTML;
      }
    });
  }

  //index coin animate
  var coinAnimateMob = document.querySelector('#coin-animate-mob');
  if (coinAnimateMob) {
    coinAnimateMob.load();
    coinAnimateMob.play();
    coinAnimateMob.setAttribute('loop', true);
    coinAnimateMob.setAttribute('muted', true);
    coinAnimateMob.setAttribute("autoPlay", true);
    console.log('kek');
  }
});

function showBitcoinAskPopup() {
  var variants = [
    {
      text: 'Do you already own <span>cryptocurrency</span><span class="popup__title_mark">?</span>',
      goal: "bitcoin_ask_popup__have_crypto",
    },
    {
      text: 'Do you have <span>Ethereum</span><span class="popup__title_mark">?</span>',
      goal: "bitcoin_ask_popup__have_eth",
    },
    {
      text: 'Have you invested in <span>Bitcoin</span><span class="popup__title_mark">?</span>',
      goal: "bitcoin_ask_popup__invested_bitcoin",
    },
    {
      text: 'Do you know what <span>bitcoin</span> is<span class="popup__title_mark">?</span>',
      goal: "bitcoin_ask_popup__know_bitcoin",
    },
    {
      text: 'Do you have <span>Metamask</span> installed<span class="popup__title_mark">?</span>',
      goal: "bitcoin_ask_popup__metamask_installed",
    }
  ];

  var variant = variants[Math.floor(variants.length * Math.random())];
  if (location.href.indexOf("bitcoin_ask_popup_question") > 0) {
    var searchedGoal = window.loadedURL.searchParams.get("bitcoin_ask_popup_question");
    variants.forEach(function(item) {
      if (item.goal === searchedGoal) {
        variant = item;
      }
    });
  }

  var $popup = $(".js-bitcoin-ask-popup");
  $popup.click(function(e) {
    if ($(e.target).closest(".popup").length === 0) {
      hideBitcoinAskPopup();
    }
  });

  $(document.body).addClass("popup-show");
  $popup.removeClass("hidden");

  $popup.find(".js-question").html(variant.text);

  $popup.find(".js-button--yes").click(function(e) {
    e.preventDefault();
    hideBitcoinAskPopup();
  });

  $popup.find(".js-button--no").click(function(e) {
    e.preventDefault();
    hideBitcoinAskPopup();
  });
}

function hideBitcoinAskPopup() {
  $(document.body).removeClass("popup-show");
  $(".js-bitcoin-ask-popup").addClass("hidden");
}

function hit(id) {
  console.log("hit " + id);
  new Image().src = "https://" + window.location.host + "/hit.php?id=" + id + "&r=" + Math.round(100000 * Math.random());
}

function ethActivate() {
  hit(window.isTooncoinCom ? 8839 : 8841);
  gtag("send", "event", "activate", "request");

  var request = window.ethereum.isMetaMask
    ? window.ethereum.request({method: "eth_requestAccounts"})
    : window.web3.eth.getAccounts();

  return request.then(function(accounts) {
      hit(window.isTooncoinCom ? 8840 : 8842);
      gtag("send", "event", "activate", "success");

      return accounts;
    }).catch(function(err) {
      gtag("send", "event", "activate", "failure");
      hit(window.isTooncoinCom ? 8843 : 8844);

      throw err;
    });
}

function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand("copy");
    var msg = successful ? "successful" : "unsuccessful";
    hit(window.isTooncoinCom ? 8851 : 8853);
    console.log("Fallback: Copying text command was " + msg);
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err);
  }

  document.body.removeChild(textArea);
}

function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(
      function() {
        hit(window.isTooncoinCom ? 8851 : 8853);
        console.log("Async: Copying to clipboard was successful!");
      },
      function(err) {
        console.error("Async: Could not copy text: ", err);
      }
  );
}

var copyBtn = document.querySelector(".copy-btn");
copyBtn && copyBtn.addEventListener("click", function(e) {
  e.preventDefault();
  copyTextToClipboard(window.toonAppData.address);
  logEvent("copy_address");
});

var hitSelectionTextHasAddressIsFired = false;
var mainBlock = document.querySelector(".main");
mainBlock && mainBlock.addEventListener("mouseup", function() {
  var text = getSelectedText();
  if (text.indexOf(window.toonAppData.address) >= 0) {
    if (hitSelectionTextHasAddressIsFired === false) {
      hitSelectionTextHasAddressIsFired = true;
      hit(window.isTooncoinCom ? 8852 : 8854);
    }
  }
});

function getSelectedText() {
  if (window.getSelection) {
    var selection = window.getSelection();

    if (selection.type === "Range") {
      return selection.toString();
    }
  } else if (document.selection) {
    return document.selection.createRange().text;
  }

  return "";
}

function debounce(name, delay, func) {
  window.debounceTimers = window.debounceTimers || {};
  clearTimeout(window.debounceTimers[name]);
  window.debounceTimers[name] = setTimeout(func, delay);

  return window.debounceTimers[name];
}

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

var apiPath = "https://pw.photo-cdn.net/api";

var faqFormIsDisabled = false;
var $faqForm = $(".faq__form");

$faqForm.submit(function(e) {
  e.preventDefault();

  if (faqFormIsDisabled) {
    return;
  }

  var $spinner = $(".lds-spinner", this);
  var $successMsg = $(".faq__form-thanks", this);
  var $errorMsg = $(".faq__form-error", this);

  var $emailField = $.trim($("#faq__form-email", this).val());
  // if (!isEmail($emailField)) {
  //   $errorMsg.show().text("invalid email");
  //   return;
  // }

  var $nameField = $.trim($("#faq__form-name", this).val());
  // if ($nameField.length === 0) {
  //   $errorMsg.show().text("invalid name");
  //   return;
  // }

  var $questionField = $.trim($("#faq__form-question", this).val());
  // if ($questionField.length === 0) {
  //   $errorMsg.show().text("invalid question");
  //   return;
  // }

  faqFormIsDisabled = true;
  $errorMsg.hide().text("");
  $spinner.css("display", "inline-block");

  $.ajax({
    method: "POST",
    url: apiPath + "/tasks/create",
    headers: {
      "X-Client-Token":"b:d:X6bDk1Pc7GByJ",
      "X-Project-Key":"X6bDk1Pc7GByJ",
    },
    data: {
      type: "feedback",
      params: {
        subject: "tooncoin feedback",
        fields: {
          email: $emailField,
          name: $nameField,
          question: $questionField,
        }
      }
    }
  })
  .done(function() {
    $spinner.hide();
    $successMsg.show();

    setTimeout(function() {
      $faqForm[0].reset();
      $successMsg.hide();
      faqFormIsDisabled = false;
    }, 5000);
  });
});

function makeClientToken() {
  var result = "";
  var map = "abcdef0123456789";
  for (var i = 0; i < 32; i++) {
    result += map.charAt(Math.floor(Math.random() * map.length));
  }

  return "b:u:" + result;
}

function logEvent(eventId, params) {
  console.log("logEvent", eventId, params);

  var clientToken = window.localStorage.getItem("client_token") || makeClientToken();
  window.localStorage.setItem("client_token", clientToken);
  var endpoint = "https://tooncoinbot.photo-cdn.net/api/events";
  var isBeacon = typeof window.navigator.sendBeacon === "function";
  var data = JSON.stringify({id: eventId, params: params});
  var projectKey = "1272e21faf16e";

  if (isBeacon) {
    window.navigator.sendBeacon(
      endpoint
      + "?project_key=" + projectKey
      + "&client_token=" + clientToken
      + "&eventdata=" + encodeURIComponent(data)
    );
  } else {
    fetch(endpoint, {
      method: "post",
      mode: "cors",
      headers:  {
        "Content-Type": "application/json",
        "X-Project-Key": projectKey,
        "X-Client-Token": clientToken
      },
      body: data
    }).then(function(res) {
      /* skip */
    }).catch(function(err) {
      console.error(err);
      /* skip */
    });
  }
}

function queryStringToObject(queryString) {
  var object = {};

  queryString
    .split("&")
    .filter(function(item) {
      return item.length > 0;
    })
    .forEach(function(item) {
      var parts = item.split("=");
      object[parts[0]] = decodeURIComponent(parts[1]);
    });

  return object;
}

function objectToQueryString(object) {
  var params = [];
  for (var key in object) {
    params.push(key + "=" + encodeURIComponent(object[key]));
  }

  return params.join("&");
}
